<script setup>
import { computed } from 'vue'
import { useTrackingStore } from '../store/tracking'

const trackingStore = useTrackingStore()

// Only show if there's history
const hasHistory = computed(() => trackingStore.recentlyViewed.length > 0)
</script>

<template>
  <router-link 
    to="/recently-viewed"
    class="fixed bottom-6 right-6 z-40 w-[50px] h-[50px] bg-gradient-to-tr from-black to-neutral-800 dark:from-neutral-950 dark:to-neutral-800 rounded-full flex items-center justify-center text-white shadow-[0_4px_20px_rgba(0,0,0,0.3)] hover:shadow-[0_8px_30px_rgba(0,0,0,0.45)] border border-zinc-800 dark:border-neutral-700/50 transition-all duration-300 transform hover:-translate-y-0.5 hover:scale-105 active:scale-95 group overflow-visible"
    aria-label="ประวัติการดูสินค้า"
  >
    <div class="relative flex items-center justify-center w-full h-full">
      <!-- Premium modern clock history icon -->
      <svg class="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5">
        <path stroke-linecap="round" stroke-linejoin="round" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"></path>
      </svg>
      
      <!-- Modern crimson count badge with border -->
      <span v-if="trackingStore.recentlyViewed.length > 0" class="absolute -top-1 -right-1 bg-red-500 text-white text-[9px] font-black px-1.5 py-0.5 rounded-full min-w-[18px] text-center shadow-md border-2 border-white dark:border-gray-900 transition-all duration-300">
        {{ trackingStore.recentlyViewed.length }}
      </span>
    </div>
    
    <!-- Ultra-modern premium speech bubble tooltip next to the button -->
    <div class="absolute right-[65px] top-1/2 -translate-y-1/2 whitespace-nowrap bg-white dark:bg-[#0c121e] border border-gray-200/50 dark:border-white/10 shadow-[0_10px_30px_rgba(0,0,0,0.08)] dark:shadow-[0_10px_30px_rgba(0,0,0,0.4)] rounded-2xl px-4 py-2.5 text-xs font-bold text-gray-800 dark:text-white flex items-center gap-1.5 opacity-0 group-hover:opacity-100 pointer-events-none transition-all duration-300 transform translate-x-2 group-hover:translate-x-0 select-none">
      <span>ดูประวัติการดูสินค้าของคุณ</span>
      <!-- Small triangle pointer -->
      <div class="absolute right-[-6px] top-1/2 -translate-y-1/2 w-2.5 h-2.5 rotate-45 bg-white dark:bg-[#0c121e] border-r border-t border-gray-200/50 dark:border-white/10"></div>
    </div>
  </router-link>
</template>

